import React from 'react';

// Pastille « moyen de paiement » (MVola jaune, Orange Money orange, carte violette) — affichée en gros dans toutes les listes de
// paiements à valider de l'admin, pour voir d'un coup d'œil comment le client a payé.
const METHODS = {
  mvola: { label: 'MVola', emoji: '🟡', cls: 'bg-yellow-400/20 text-yellow-200 border-yellow-400/50' },
  orange: { label: 'Orange Money', emoji: '🟠', cls: 'bg-orange-500/20 text-orange-200 border-orange-400/50' },
  orange_money: { label: 'Orange Money', emoji: '🟠', cls: 'bg-orange-500/20 text-orange-200 border-orange-400/50' },
  card: { label: 'Carte bancaire', emoji: '💳', cls: 'bg-violet-500/20 text-violet-200 border-violet-400/50' },
  stripe: { label: 'Carte bancaire', emoji: '💳', cls: 'bg-violet-500/20 text-violet-200 border-violet-400/50' },
  other: { label: 'Autre', emoji: '•', cls: 'bg-white/10 text-gray-200 border-white/20' },
};

export default function PaymentMethodBadge({ method, className = '' }) {
  const key = String(method || '').toLowerCase();
  const m = METHODS[key] || { label: method || 'Moyen non précisé', emoji: '❔', cls: 'bg-rose-500/15 text-rose-200 border-rose-400/40' };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full border text-xs font-bold whitespace-nowrap ${m.cls} ${className}`}>
      <span aria-hidden="true">{m.emoji}</span> {m.label}
    </span>
  );
}
